module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs notes-list"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n        通话记录(" + _vm._s(_vm.page.total) + "次)\n      ")])]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "call-list"
  }, [(!_vm.tableData.length) ? _c('li', {
    staticClass: "item center"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('li', {
      staticClass: "item"
    }, [(_vm.showDate(index)) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm._f("onlyDate")(item.callTimeShow)))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "infos"
    }, [_c('div', {
      staticClass: "target"
    }, [_c('span', {
      staticClass: "icon"
    }, [(!item.type) ? _c('i', {
      staticClass: "web-icon-callin"
    }) : _vm._e()]), _vm._v(" "), (item.refType === 3 && _vm.moduleName !== 'contactApi') ? _c('span', {
      staticClass: "name",
      on: {
        "click": function($event) {
          _vm.openDetail(item.refId)
        }
      }
    }, [_vm._v(_vm._s(item.refName))]) : _c('span', [_vm._v(_vm._s(item.refName))])]), _vm._v(" "), _c('div', {
      staticClass: "duration"
    }, [(item.result) ? _c('span', [_vm._v("\n                " + _vm._s(_vm._f("formatTime")(item.duration)) + "\n              ")]) : _c('span', {
      staticClass: "red"
    }, [_vm._v("\n                通话失败\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "call-time"
    }, [_vm._v(_vm._s(_vm._f("onlyTime")(item.callTimeShow)))]), _vm._v(" "), _c('div', {
      staticClass: "options"
    }, [(item.recordUrl) ? _c('audio', {
      staticClass: "audio",
      attrs: {
        "controls": "controls",
        "src": item.recordUrl
      }
    }) : _c('span', [_vm._v("无")])])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(_vm.showLoadmore) ? [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n        加载更多\n      ")] : _vm._e(), _vm._v(" "), (!_vm.showLoadmore && _vm.page.total > _vm.page.pageSize) ? [_vm._v("没有更多")] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61cf092c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/call-log.vue
// module id = 1287
// module chunks = 82